'use client';

import { COOKIE_NAMES } from '@utils/constants';

import { Modal, Select } from 'antd';
import Typography from 'antd/lib/typography';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
import * as React from 'react';
import { useEffect } from 'react';
import { Membership } from 'shared/src/types';

type Props = Readonly<{
  memberships?: Membership[];
  orgId?: string;
  link: string;
  onCancel?: () => void;
}>;

const DEFAULT_MEMBERSHIPS: Membership[] = [];

export const OrganizationRedirectModal: React.FC<Props> =
({ memberships = DEFAULT_MEMBERSHIPS, orgId, link, onCancel }) => {
  const [open, setOpen] = React.useState(true);
  const [selectedOrg, setSelectedOrg] = React.useState(orgId || memberships[0]?.tenant);
  const windowSplice = -2;
  const domain = window?.location?.hostname.split('.').splice(windowSplice).join('.');
  // NOTE: will break if no main workspace exists
  const orgUrl = `main-${selectedOrg}.${domain}/${link}`
    .replace(/\/\//g, '/')
    .replace(/%2F/, '/')
    .replace(/%3F/, '?')
    .replace(/%3D/, '=')
    .replace(/%26run%3Dtrue/, '&run=true');

  useEffect(() => {
    const orgFromCookie = getCookie('selectedOrg');

    if (orgFromCookie) {
      setSelectedOrg(orgFromCookie);
    } else if (memberships[0]?.tenant) {
      setSelectedOrg(memberships[0].tenant);
    }
  }, [memberships]);

  const handleOk = (): void => {
    window?.location?.replace(`https://${orgUrl}`);
    deleteCookie(COOKIE_NAMES.CRIBL_DOCS);
  };

  const handleCancel = (): void => {
    setOpen(false);
    deleteCookie(COOKIE_NAMES.CRIBL_DOCS);
    onCancel?.();
  };

  const handleChange = (value: string): void => {
    setSelectedOrg(value);
    setCookie('selectedOrg', value);
  };

  return (
    <Modal
      open={open}
      title='Link Verification'
      onCancel={handleCancel}
      onOk={handleOk}
      data-testid='search-modal'
    >
      <Typography.Paragraph>Looks like you are following a link!</Typography.Paragraph>

      {memberships.length > 1 && (
        <>
          <Typography.Paragraph>Select Organization:</Typography.Paragraph>

          <Select
            key='organization-select'
            onChange={handleChange}
            defaultValue={selectedOrg}
            style={{ width: '100%' }}
          >
            {memberships.map((membership) => (
              <Select.Option
                key={membership.tenant}
                value={membership.tenant}
              >
                {membership.tenant}
              </Select.Option>
            ))}
          </Select>
        </>
      )}

      <Typography.Paragraph> Here is where it will take you:</Typography.Paragraph>

      <Typography.Paragraph
        data-testid='search-redirect-link'
        code
      >
        {orgUrl}
      </Typography.Paragraph>
    </Modal>
  );
};
